import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: 'var(--font-stack)',
  },
  palette: {
    secondary: {
      main: '#24bbaa',
      contrastText: '#171717'
    },
    text: {
      primary: '#171717',
      secondary: '#171717',
    },
    background: { default: '#ffffff' },
  },
  components: {
    MuiButton: {
      styleOverrides: { root: { textTransform: 'none', borderRadius: 10, fontWeight: 600 } },
    },
    MuiToolbar: {
      styleOverrides: { root: { height: '72px' } },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          display: 'none',
        },
      },
    },
     MuiButtonBase: {
      styleOverrides: {
        root: {
          '& .MuiTouchRipple-root': {
            color: '#24bbaa',
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '.RaLayout-appFrame': {
          marginTop: '72px !important',
        },
        '.RaLayout-content': {
          padding: '0 !important',
        },
        '.MuiPaper-root': {
          boxShadow: 'none !important',
        },

      },
    },
  },
});